module.exports = __webpack_public_path__ + "static/media/8OLA30.1452ffc9.jpg";